// 获取参数
export const getUrlParam = function(name) {
    const parmsStr = window.location.search.substring(1);
    const parmsArr = parmsStr.split('&');
    const parms = {};
    for (let i = 0; i < parmsArr.length; i++) {
        parms[parmsArr[i].split('=')[0]] = parmsArr[i].split('=')[1];
    }
    return parms[name];
};

export const throttle = function(method, delay, duration) {
    let timer = null,
        begin = new Date();
    return function() {
        let context = this,
            args = arguments,
            current = new Date();
        clearTimeout(timer);
        if (current - begin >= duration) {
            method.apply(context, args);
            begin = current;
        } else {
            timer = setTimeout(() => {
                method.apply(context, args);
            }, delay);
        }
    };
};
// 防抖
export const debounce = function(method, delay) {
    // 定时器，用来 setTimeout
    var timer;

    // 返回一个函数，这个函数会在一个时间区间结束后的 delay 毫秒时执行 fn 函数
    return function() {
        // 保存函数调用时的上下文和参数，传递给 fn
        var context = this;
        var args = arguments;

        // 每次这个返回的函数被调用，就清除定时器，以保证不执行 fn
        clearTimeout(timer);

        // 当返回的函数被最后一次调用后（也就是用户停止了某个连续的操作），
        // 再过 delay 毫秒就执行 fn
        timer = setTimeout(function() {
            method.apply(context, args);
            console.log(123456);
        }, delay);
    };
};

// 获取平台
export const platform = function() {
    const userAgent = navigator.userAgent;
    const isWechat = /MicroMessenger/i.test(userAgent);
    let platform = '';
    if (isWechat) {
        platform = 'WX';
    } else {
        const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
        const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isIOS) {
            platform = 'IPH';
        } else if (isAndroid) {
            platform = 'ADR';
        } else {
            platform = 'PC';
        }
    }
    return platform;
};


// 数字格式化

export const numsFormat = (num) => {
    if (num < 10000) {
        return num;
    }
    const n = parseInt(num / 10000, 10);
    let other = num % 10000;
    other = parseInt(other / 1000, 10);
    if (other > 0) {
        return `${n}.${other}万`;
    }
    return `${n}万`;
};


export function changeTitle(title) {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const isWechat = /MicroMessenger/i.test(navigator.userAgent);
    // 0是隐藏，1是显示

    document.title = title;
    document.getElementsByTagName('title')[0].innerText = title;

    if (isWechat) return;
    if (isAndroid) {
        if (window.WebViewJavascriptBridge) {
            window.WebViewJavascriptBridge.callHandler(
                'setTitle', { title },
                (responseData) => {
                    console.log(responseData);
                    //  window.alert('success')
                },
            );
        } else {
            document.addEventListener(
                'WebViewJavascriptBridgeReady', () => {
                    window.WebViewJavascriptBridge.callHandler(
                        'setTitle', { title },
                        (responseData) => {
                            console.log(responseData);
                            // window.alert('success')
                        },
                    );
                },
                false,
            );
        }
    } else if (isIOS) {
        // 检测是已创建script
        //  var hasBuildScript=document.getElementById('IOS_setTitle')
        //   if (hasBuildScript) {
        //       document.body.removeChild(hasBuildScript)
        //       var script = document.createElement('script');
        //           script.id = 'IOS_setTitle';
        //           script.innerHTML='try {window.webkit.messageHandlers.setTitle.postMessage({title: "'+title+'"});}catch(e){console.log(e)}'

        //           document.body.appendChild(script)
        //   }else{

        //      var script = document.createElement('script');
        //          script.id = 'IOS_setTitle';
        //          script.innerHTML='try{window.webkit.messageHandlers.setTitle.postMessage({title: "'+title+'"});}catch(e){console.log(e)}'

        //          document.body.appendChild(script)
        //   }
        if (location.href.indexOf('appencrypt') !== -1) {
            location.href = `title://a.com?title=${title}`;
        }
    } else {
        console.log('pc');
    }
}



// WEBPACK FOOTER //
// ./src/utils/common.js